export function FeatureItem(props: { icon: string; text: string }) {
  return (
    <div class="flex items-center gap-3">
      <div class="flex size-10 shrink-0 items-center justify-center">
        <img src={props.icon} width={40} height={40} alt="" />
      </div>
      <span class="text-sm font-semibold text-white">{props.text}</span>
    </div>
  )
}
